import { format } from 'owa-localize';
import BodyType from 'owa-service/lib/contract/BodyType';
import getDefaultComposeContentBlock from './getDefaultComposeContentBlock';
import convertInlineCssForHtml from './convertInlineCssForHtml';

// The capital 'S' is important to match jsMVVM
// TODO:45086 Move away from ID and use class to have properly formatted HTML.
const SIGNATURE_ID = 'Signature';

export default function createSignatureBlock(
    bodyType: BodyType,
    fullSignature: string,
    isAutoSignature?: boolean
): string {
    let signatureBlock = '';
    if (fullSignature && !isSignatureEmpty(bodyType, fullSignature)) {
        if (bodyType == 'HTML') {
            // Create two lines of spaces above the signature and wrap signature with id='Signature'.
            // Also, the empty two lines need to carry default format
            const defaultContentBlock = getDefaultComposeContentBlock();

            // The content from signature is wrapped within <html> and <body> tag
            // Let the content go through roosterjs.convertInlineCss
            // convertInlineCss does either of two things:
            // 1) do css inlining
            // Or
            // 2) remove the <html> and <body> wrapping when any global style is present
            // For here, we're mostly leveraging 2) since we don't have any global style in signature
            const signatureContent = convertInlineCssForHtml(fullSignature, bodyType);

            // For the auto signature, we need to add two empty line
            // For the manual signature, since there is already "insert in new line" option, only need add one empty line
            // And the result is the same, there are two empty line above the signature.
            signatureBlock = isAutoSignature
                ? defaultContentBlock + defaultContentBlock
                : defaultContentBlock;
            signatureBlock += format("<div id='{0}'>{1}</div>", SIGNATURE_ID, signatureContent);
        } else {
            /* bodyType == "Text" */
            signatureBlock = '\n\n' + fullSignature;
        }
    }

    return signatureBlock;
}

function isSignatureEmpty(bodyType: BodyType, signature: string): boolean {
    if (bodyType == 'HTML') {
        // DOMParser returns a HTML document. Need to get the HTML document element;
        const checkEl = new DOMParser().parseFromString(signature, 'text/html').documentElement;
        if (checkEl && checkEl.innerText) {
            const signatureInnerText = checkEl.innerText.replace(/(\t|\n|\r|\v|\f)/g, '');
            const signatureImgElList = checkEl.querySelectorAll('img[src]:not([src=""])');
            return !signatureInnerText && signatureImgElList.length == 0;
        }
        return true;
    }
    return !signature;
}
